import React from "react";
import { Link } from "react-router-dom";

const Header = ( {pageTitle} ) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const toggleBodyClass = () => {
    const body = document.body; // select body
    if (body.classList.contains("nav-md")) {
      body.classList.remove("nav-md");
      body.classList.add("nav-sm");
    } else {
      body.classList.remove("nav-sm");
      body.classList.add("nav-md");
    }
  };

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");

  return (
    <div className="top_nav">
      <div className="nav_menu" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="nav toggle">
            <Link id="menu_toggle" onClick={toggleBodyClass}>
              <i className="far fa-ellipsis-v-alt" aria-hidden="true"></i>
            </Link>
          </div>
          {pageTitle && (
            <div  style={{ marginLeft: "20px", fontSize: "18px", fontWeight: 600 }}>
              {pageTitle}
            </div>
          )}
        </div>
        <nav className="nav navbar-nav">
          <ul className="navbar-right">
            <li className="nav-item dropdown open" style={{ paddingLeft: "15px" }}>
              <Link href="#" className="user-profile">
                <img src={`${process.env.PUBLIC_URL || ""}/assets/images/adminicon.png`} alt="admin" /> Welcome {adminUser.name || "Admin"}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;
